import { translate, translateFormatter, type RichTextFormatter } from '@/domains/core/localization/translate';
export const {
  sponsorInfoBannerNoUserSegmentDescription
} = translate({
  "sponsorInfoBannerNoUserSegmentDescription": "Advertising displayed without regard to your activity on ManoMano."
});
export const sponsorInfoBannerWithUserSegmentsDescription = translateFormatter<{
  a: RichTextFormatter;
}>("Advertising displayed based on your account data and/or your activity on ManoMano. <a>Find out more</a>.", undefined, undefined, "en");